import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import App from "../App";
import { useAuth } from "../Contexts/auth.context";
import { Suspense } from "react";
import Loading from "../components/loading/loading.component";
import GraphMomentum from "../Pages/Public/graph-momentum/GraphMomentum";
import GraphExample from "../Pages/Public/graph-example/GraphExample";
import UserDetailpage from "../Pages/Public/WebReports/UserDetailpage";
import ProfitLossReport from "../Pages/Public/WebReports/ProfitLossReport";
import RoyaltyReport from "../Pages/Public/WebReports/RoyaltyReport";
import ProfitReportSymbol from "../Pages/Public/WebReports/ProfitReportSymbol";
import DepositWithdraw from "../Pages/Public/WebReports/DepositWithdraw";
import FeeReport from "../Pages/Public/WebReports/FeeReport";
import { lazyWithRetry } from "../Utils/lazyWithRetry";
import ContactUs from "../Pages/Public/contact-us/ContactUs";
import AuthLayout from "../Layouts/AuthLayout";
import MasterLayout from "../Layouts/MasterLayout";
import SupportCenter from "../Pages/Public/support-center/SupportCenter";
import LatestNews from "../Pages/Public/latest-news/LatestNews";
import FAQs from "../Pages/Public/faqs/FAQs";
import PrivacyNotice from "../Pages/Public/privacy-notice/PrivacyNotice";
import Disclaimer from "../Pages/Public/disclaimer/Disclaimer";
import TermsAndConditions from "../Pages/Public/terms-and-conditions/TermsAndConditions";
import InfluncerEnrollment from "../Pages/Influence/InfluenceEnrollment/InfluncerEnrollment";
import InfluencerProfile from "../Pages/Influence/InfluencerProfile/InfluencerProfile";
import InfluencerAnalytics from "../Pages/Influence/InfluencerAnalytics/InfluencerAnalytics";
import InfluencerInvite from "../Pages/Influence/InfluencerInvite/InfluencerInvite";
import InfluenceAuctionListPage from "../Pages/Influence/InfluenceAuctionListPage/InfluenceAuctionListPage";
import InfluencerRating from "../Pages/Influence/InfluencerRating/InfluencerRating";
import InfluencerAcknowledge from "../Pages/Influence/InfluencerAcknowledge/InfluencerAcknowledge";
import PaypalWebview from "../Pages/PaypalWebview/PaypalWebview";
import PaypalWebviewAuction from "../Pages/PaypalWebviewAuction/PaypalWebviewAuction";
import MyInfluencer from "../Pages/Influence/MyInfluencer/MyInfluencer";
import PublicAuctionDetails from "../Pages/Public/auction-details-public/PublicAuctionDetails";

const { PUBLIC_URL } = process.env;


//LOADING ONLY WHEN IT'S NEEDED.
const AuthPage = lazyWithRetry(() => import("./auth.routes"));
const ErrorPage = lazyWithRetry(() => import("./error.routes"));
const PublicPage = lazyWithRetry(() => import("./public.routes"));

const AppRoutes = () => {
    const { currentUser } = useAuth();

    const getRedirectPath = () => {
        if (!currentUser) {
            const returnUrl = window.location.pathname + window.location.search;
            if (returnUrl === '/logout') {
                return '/auth';
            }
            const hasAuthInReturnUrl = returnUrl.includes('/auth');
            const encodedReturnUrl = hasAuthInReturnUrl
                ? returnUrl
                : encodeURIComponent(returnUrl);
            return hasAuthInReturnUrl
                ? `/auth?returnUrl=${encodedReturnUrl}`
                : `/auth?returnUrl=${encodedReturnUrl.replace('%2F', '/')}`;
        }
        return '/auth';
    };

    return (
        <BrowserRouter basename={PUBLIC_URL} hasError>
            {/* DISPLAYS THE LOADING COMPONENT UNTIL THE ROUTES ARE READY */}
            <Suspense fallback={<Loading />}>
                <Routes>
                    <Route path="graph-momentum" element={<GraphMomentum />} />
                    <Route path="graph-example" element={<GraphExample />} />
                        <Route path="paypalWebview" element={<PaypalWebview />} />
                        <Route path="paypalWebview-auction" element={<PaypalWebviewAuction />} />
                    <Route element={<App />}>
                        <Route path="influncer-profile" element={<InfluencerProfile />} />
                        <Route path="influncer-auction-list" element={<InfluenceAuctionListPage />} />
                        <Route path="influncer-enrollment" element={<InfluncerEnrollment />} />
                        <Route path="influncer-analytics" element={<InfluencerAnalytics />} />
                        <Route path="influncer-invite" element={<InfluencerInvite />} />
                        <Route path="influncer-ratings" element={<InfluencerRating />} />
                        <Route path="influncer-ackownledge" element={<InfluencerAcknowledge />} />
                        <Route path="my-influencer" element={<MyInfluencer />} />
                        <Route path="error/*" element={<ErrorPage />} />
                        {currentUser ? (
                            <>
                                <Route path="/*" element={<PublicPage />} />
                                <Route index element={<Navigate to="/auctions-board" />} />
                            </>
                        ) : (
                            <>
                                <Route path="auth/*" element={<AuthPage />} />
                                <Route path="auctions-board/auction" element={<PublicAuctionDetails />} />
                                <Route index element={<Navigate to={getRedirectPath()} />} />
                                <Route path="*" element={<Navigate to={getRedirectPath()} />} />
                            </>
                        )}
                    </Route>
                    <Route>
                        <Route element={<UserDetailpage />} path="/user-detail-page" />
                        <Route element={<ProfitLossReport />} path="/profit-loss-report" />
                        <Route element={<RoyaltyReport />} path="/royalty-report" />
                        <Route element={<ProfitReportSymbol />} path="/profit-report" />
                        <Route element={<DepositWithdraw />} path="/deposit-withdraw" />
                        <Route element={<FeeReport />} path="/fee-report" />

                        {/*Footer links --- start*/}
                        <Route element={<MasterLayout />}>
                            <Route element={<AuthLayout />}>
                                <Route path="contact-us" element={<ContactUs />} />
                                <Route path="support-center" element={<SupportCenter />} />
                                <Route path="latest-news" element={<LatestNews />} />
                                <Route path="FAQs" element={<FAQs />} />
                                <Route path="privacy-policy" element={<PrivacyNotice />} />
                                <Route path="disclaimer" element={<Disclaimer />} />
                                <Route path="terms-conditions" element={<TermsAndConditions />} />
                                {/*Footer links --- end*/}
                            </Route>
                        </Route>


                    </Route>
                </Routes>
            </Suspense>
        </BrowserRouter>
    );
};

export { AppRoutes };
